import { render, staticRenderFns } from "./AgentsEdit.vue?vue&type=template&id=0c285e7e&"
import script from "./AgentsEdit.vue?vue&type=script&lang=ts&"
export * from "./AgentsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AgentsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgentsEdit.vue"
export default component.exports